// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kfYHj","footerDiv":"Footer_footerDiv__0PSC1"};